import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';

export function registerAgGridModules(): void {
    ModuleRegistry.registerModules([AllCommunityModule]);
}

/** Quartz theme via the AG Grid Theming API (v33+). Do not import ag-grid.css. */
export const AG_GRID_THEME = themeQuartz.withParams({
    fontFamily: 'Lato, Roboto, sans-serif',
    fontSize: 16
});
